import { createGlobalStyle } from 'styled-components';
import 'elmo-elements/main.css';
import { addRootConfig, getBreakPoint } from './helpers';

export const GlobalStyle = createGlobalStyle`
  :root {
    ${addRootConfig()}
  }

  .white-bg {
      background: #fff;

      body {
          background: #fff;
      }
  }
  
  .elmo-icon {
    &&&&__color-gray {
      color: var(--black-600);
    }
  }

  &&& nav.elmo-pagination {
    position: relative;
  }

  .elmo-notification {
    .elmo-notification__item {
      .elmo-notification__text {
        max-width: calc(100% - 50px);
      }
    }
  }
  
  .elmo-notification {
    .elmo-notification__item.elmo-notification__item--danger {
      .elmo-btn.elmo-notification__close {
        color: var(--black-700);
      }
    }
  }

  .elmo-layout__main-content {
      @media (min-width: ${getBreakPoint('xl')}) {
          min-height: 100%;
      }
  }

  .w-100 {
    width: 100%;
  }

  .mw-100 {
    max-width: 100%;
  }
  
  #common-error-dialog {
    .elmo-modal__header{
      .elmo-modal__header-title .elmo-typography{
        font-weight: 300
      }
    }

    .elmo-modal__body {
      font-size: 1.3rem;
      font-weight: 300
    }
  }
  
  .elmo-notification {
    z-index: 1001 !important;
  }
  
  .elmo-popover-base__content--delay-visibility {
    .elmo-popover__content {
      background: rgb(255 229 143 / 75%) !important;
      width: 350px !important;
    }
  }

  .elmo-popover {
    &.elmo-popover--hover {
      margin-left: 6px;

      .elmo-icon--size-md {
        .elmo-icon__svg {
          color: var(--black-700);
          font-size: 26px;
        }
      }
    }
  }
  
    &.required {
        label::after {
          margin-left: 3px;
          color: var(--danger-600);
          content: '*';
          font-size: 14px;
          line-height: 24px;
        }
    }
  
  .elmo-listtable__header-col {
      padding: 0;
  }
  
  .elmo-listtable__data {
      .elmo-badge--success {
          background-color: #7FD5B5;
          color: black;
      }
      
      .elmo-badge--warning {
          background-color: #FDE68A;
          color: black;
      }
      
      .elmo-badge--grey {
          background-color: #D9D9D9;
          color: black;
      }
      
      .elmo-badge--danger {
          background-color: #FCA5A5;
          color: black;
      }
  }

  .elmo-tooltip__content {
      background: #ffffff;
      color: var(--black-900);
      border: 1px solid rgba(0, 0, 0, 0.14);
      max-width: 170px;
      padding: 7px 14px;
      font-weight: normal;
  }
  
  .elmo-dropdown__divider--short {
    margin-left: 0
  }
  
  @media (max-width: 1279.9px) {
   .elmo-layout__main-app {
        padding-top: 20px;
    }
  }

    button.elmo-btn--default:not(:disabled) {
        .elmo-icon {
            color: var(--information-700);
        }
    }

    .elmo-listtable__data:empty:before {
        color: var(--black-450);
        content: '—';
    }

  .elmo-layout__main-content {
      padding-top: 24px;
      padding-bottom: 24px;
  }
  
  .elmo-layout {
      @media (max-width: 1280px) {
          padding-top: 15px;
      }
  }
  // global css list table fix
  .elmo {
      &-listtable {
          &__row-wrapper {
              .elmo-listtable__row {
                  @media (min-width: ${getBreakPoint('md')}) {
                      flex-wrap: nowrap;
                  }
              }

              .elmo-listtable__cols {
                  max-width: calc(100% - 16px - 48px);
              }

              .elmo-col {
                  &.elmo-listtable {
                      &__col {
                          .elmo-listtable__data {
                              overflow-x: hidden;
                              white-space: break-spaces;
                              text-overflow: ellipsis;
                          }
                      }
                  }
              }
          }
      }
  }
`;
